<template>
  <div class="member_info_wrap">
    <el-form :model="memberForm" :rules="memberRules" ref="memberForm" label-width="120px">
      <!-- <el-divider content-position="left" class="myDivider">个人信息</el-divider> -->
      <div class="myDivider">个人信息</div>
      <el-row class="label_width">
        <el-col :span="8">
          <el-form-item label="姓名" prop="memberName">
            <el-input v-model="memberForm.memberName" placeholder="请输入姓名" class=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="生日" prop="birthday">
            <el-date-picker type="date" placeholder="请选择出生日期" v-model="memberForm.birthday" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="年龄" prop="memberAge">
            <el-input v-model="memberForm.memberAge" type="number" placeholder="请输入年龄" class=""></el-input>
          </el-form-item>
        </el-col>
        </el-col>
      </el-row>

      <el-row class="label_width">
        <el-col :span="8">
          <el-form-item label="性别" prop="memberSex">
            <el-radio-group v-model="memberForm.memberSex">
              <el-radio-button label="1">男</el-radio-button>
              <el-radio-button label="2">女</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身份证号码" prop="idNo">
            <el-input v-model="memberForm.idNo" placeholder="请输入身份证号码" class=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="籍贯" prop="nativePlace">
            <el-input v-model="memberForm.nativePlace" placeholder="请输入籍贯" class=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row class="label_width">
        <el-col :span="8">
          <el-form-item label="民族" prop="nation">
            <el-input v-model="memberForm.nation" placeholder="请输入民族" class=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="身高(cm)" prop="height">
            <el-input v-model="memberForm.height" placeholder="请输入身高" class="" @blur="getBmiBlur"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="体重(kg)" prop="weight">
            <el-input v-model="memberForm.weight" placeholder="请输入籍贯" class="" @blur="getBmiBlur"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row class="label_width">
        <el-col :span="8">
          <el-form-item label="BMI" prop="bmi">{{memberForm.bmi}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="血型" prop="bloodType">
            <el-input v-model="memberForm.bloodType" placeholder="请输入血型" class=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="医保卡号" prop="medicalInsuranceCardNumber">
            <el-input v-model="memberForm.medicalInsuranceCardNumber" type="number" placeholder="请输入年龄医保卡" class=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="患者备注">
        <el-input v-model="memberForm.memberRemark" :rows="5" type="textarea" class="baseInp"></el-input>
      </el-form-item>
      <div class="myDivider">联系方式</div>
      <el-row class="label_width">
        <el-col :span="8">
          <el-form-item label="手机" prop="photoNumber">
            <el-input v-model="memberForm.photoNumber" type="number" placeholder="请输入手机号码" class=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电话" prop="landline">
            <el-input v-model="memberForm.landline" type="number" placeholder="请输入电话号码" class=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="微信" prop="wechatNo">
            <el-input v-model="memberForm.wechatNo" placeholder="请输入微信号" class=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="label_width">
        <el-col :span="8">
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="memberForm.email" placeholder="请输入邮箱号码" class=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="住址">
            <!-- <area-address :addressArray="memberForm.memberAddress" @getAddress="getAddress" /> -->
            <areaPicker :areaList="areaList" @getAreaData="getAreaData" class="" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="详细地址">
            <el-input v-model="memberForm.homeAddress" placeholder="请输入详细地址" class=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="myDivider">会员信息</div>
      <el-row class="label_width">
        <el-col :span="8">
          <el-form-item label="绑定门店" prop="storeName">
            <el-select v-model="memberForm.storeName" filterable placeholder="请选择归属门店" @change="getStoreId" class="" :disabled="memberForm.id != undefined">
              <el-option v-for="(item,index) in storeList" :key="index" :label="item.storeName" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="慢病情况" prop="memberLabelIds" v-if="memberForm.id == undefined">
            <el-checkbox-group v-model="memberLabelIds">
              <el-checkbox-button v-for="(item, index) in memberLabelList" :label="item.id" :key="index">{{item.labelName}}</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="慢病情况" v-else>
            <el-tag class="label_tag" effect="dark" v-for="(item, index) in memberForm.memberLabelNames" :key="index">{{item}}</el-tag>
          </el-form-item>

          <!-- <el-form-item label="慢病情况" prop="memberLabelId">
             <el-radio-group v-model="memberForm.memberLabelId" :disabled="memberForm.id">
               <el-radio-button v-for="(item, index) in memberLabelList" :label="item.id" :key="index">{{item.labelName}}</el-radio-button>
             </el-radio-group>
            </el-form-item> -->
        </el-col>
        <el-col :span="8">
          <el-form-item label="会员等级" prop="memberLevel">
            <el-radio-group v-model="memberForm.memberLevel" disabled>
              <el-radio-button label="1">普通</el-radio-button>
              <el-radio-button label="2">付费vip</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="label_width">
        <el-col :span="8">
          <el-form-item v-if="false" label="来源药企" prop="enterpriseName">{{memberForm.enterpriseName}}</el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item v-if="false" label="健康管理师" prop="healthManagePersonName">{{memberForm.healthManagePersonName}}</el-form-item>
        </el-col>
        <el-col :span="8">
        </el-col>
      </el-row>
      <div class="myDivider">家庭关系 <el-button type="success" @click="addRelationshp">+添加</el-button>
      </div>
      <!-- <el-form-item label=""> -->
      <div class="familsItem" v-for="(item,index) in memberFamilyList" :key="index">
        <div class="familsInp">
          <span class="label">姓名</span>
          <el-input v-model="memberFamilyList[index].familyName" placeholder="请输入姓名" class="smallInp"></el-input>
        </div>
        <div class="familsInp">
          <span class="label">手机号码</span>
          <el-input v-model="memberFamilyList[index].phoneNumber" placeholder="请输入手机号码" class="smallInp"></el-input>
        </div>
        <div class="familsInp">
          <span class="label">关系</span>
          <el-select v-model="memberFamilyList[index].relationship" placeholder="请选择关系" class="smallInp">
            <el-option label="父亲" :value="0">父亲</el-option>
            <el-option label="母亲" :value="1">母亲</el-option>
            <el-option label="儿子" :value="2">儿子</el-option>
            <el-option label="女儿" :value="3">女儿</el-option>
            <el-option label="配偶" :value="4">配偶</el-option>
          </el-select>
        </div>
        <el-button type="danger" @click="delRelationshp(index, item.id)">删除</el-button>
      </div>
      <div v-if="memberFamilyList.length === 0" class="tips">暂无添加家庭成员</div>
      <div class="myDivider">既往史</div>
      <el-row class="label_width">
        <el-col :span="8">
          <el-form-item label="既往病史">
            <el-input v-model="memberForm.anamnesis" placeholder="请输入疾病史" class=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="药物过敏史">
            <el-input v-model="memberForm.drugAllergyHistory" placeholder="请输入药物过敏史" class=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="用药史">
            <el-input v-model="memberForm.medicationHistory" placeholder="请输入用药史" class=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="label_width">
        <el-col :span="8">
          <el-form-item label="家族遗传病史">
            <el-input v-model="memberForm.familyHistory" placeholder="请输入家族遗传病史" class=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="myDivider">建档信息</div>
      <el-form-item label="建档资料"><span class="tip">上传建档资料，最多支持9张图片</span></el-form-item>
      <el-form-item label="">
        <uploads :imageArr="filingMaterials" :imgLength="9" @success="getUrls(arguments, 'filingMaterials')" />
      </el-form-item>
      <el-form-item label="检查报告"><span class="tip">上传体检报表、病例档案等信息，最多支持9张图片</span></el-form-item>
      <el-form-item label="">
        <uploads :imageArr="inspectionReport" :imgLength="9" @success="getUrls(arguments, 'inspectionReport')" />
      </el-form-item>
    </el-form>
    <div class="baseInfoBtns">
      <el-button type="danger" @click="isEdit">取消</el-button>
      <el-button type="success" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import AreaSelectPicker from '@/components/common/AreaSelect';
import areaAddress from '@/components/common/areaAddress';
import validate from '@/utils/validate.1.0';
import uploads from '@/components/common/uploads';
import areaPicker from '@/components/common/form/area_picker';
export default {
  components: { AreaSelectPicker, uploads, areaAddress, areaPicker },
  props: {
    isShow: Boolean,
    memberId: Number, // 会员ID
    pageType: { // 页面类型 1:会员列表 2:慢病会员
      type: String,
      default: '1'
    },
    // memberForm: { // 会员表单
    //   type: Object,
    //   default: function () {
    //     return {};
    //   }
    // },
  },
  watch: {
    // memberForm: {
    //   handler: function(n, o) {
    //     let memberAddress = n.memberAddress && n.memberAddress.split(",") || '';
    //     if (n.memberSex) {
    //       n.memberSex = n.memberSex == '男' ? '1': '2';
    //     }
    //     if (memberAddress) {
    //       this.preSelectItem = { province: memberAddress[0], city: memberAddress[1], area: memberAddress[2], areaCode: '' };
    //     }
    //     this.memberLabelIds = n.memberLabelIds || [];
    //     this.memberFamilyList = n.memberFamilyList || [];
    //     // console.log(n, o);
    //   },
    //   // deep:true
    //   immediate: true
    // },
    memberId: {
      handler: function (n, o) {
        if (n) {
          this.getMemberInfo();
        } else {
          this.memberForm = {};
          this.$refs.memberForm && this.$refs.memberForm.clearValidate();
        }
      },
      immediate: true
    },
    isShow: {
      handler: function (n, o) {
        if (n) {
          console.log('会员表单组件状态===========>', n);
          let memberAddress = this.memberForm.memberAddress && this.memberForm.memberAddress.split(",") || '';
          if (this.memberForm.memberSex) {
            this.memberForm.memberSex = this.memberForm.memberSex == '男' ? '1' : '2';
          }
          if (memberAddress) {
            this.preSelectItem = { province: memberAddress[0], city: memberAddress[1], area: memberAddress[2], areaCode: '' };
          }
          if (!this.memberForm.memberLevel) {
            this.memberForm.memberLevel = '1';
          }
          this.memberLabelIds = this.memberForm.memberLabelIds || [];

          // if (this.memberForm.memberLabelIds && this.memberForm.memberLabelIds.length > 0) {
          //   this.memberForm.memberLabelId = this.memberForm.memberLabelIds[0];
          // }

          this.memberFamilyList = this.memberForm.memberFamilyList || [];
        }
      },
      // deep:true
      immediate: true
    }
    // memberForm(n, o) {
    // }
  },
  created() {
    this.getStoreList();
    this.getLabelList();
  },
  data() {
    return {
      memberRules: this.getMemberRules(), // 规则
      loginData: JSON.parse(localStorage.getItem('loginData')) || {}, // 登录药企基本信息
      yqData: JSON.parse(localStorage.getItem('yqData')) || {}, // 登录药企基本信息
      storeList: [], // 门店列表
      preSelectItem: { province: '', city: '', area: '', areaCode: '' }, // 地区
      memberLevel: [], // 会员等级
      memberLabelIds: [], // 会员标签
      // memberLabelIds: '', // 会员标签
      memberLabelList: [], // 会员标签
      memberFamilyList: [], // 家庭成员
      filingMaterials: [], // 建档资料
      inspectionReport: [], // 检查报告
      memberForm: {}, // 会员表单
      areaList: [],
    }
  },
  methods: {
    getAddress(adrs) { // 获取地址
      this.memberForm.memberAddress = adrs;
    },
    initAreaForm() { // 初始化表单省市区
      this.memberForm.province = '';
      this.memberForm.city = '';
      this.memberForm.area = '';
    },
    getAreaData(item) { // 获取省市区 length=3 省市区 length=2 省区
      console.log(item);
      this.areaList = item.codes;
      this.initAreaForm();
      if (item.codes.length === 3) {
        this.memberForm.province = item.codes[0];
        this.memberForm.city = item.codes[1];
        this.memberForm.area = item.codes[2];
        this.memberForm.memberAddress = item.names[0] + ',' + item.names[1] + ',' + item.names[2];
      } else {
        this.memberForm.province = item.codes[0];
        this.memberForm.area = item.codes[1];
        this.memberForm.memberAddress = item.names[0] + ',' + item.names[1];
      }
      console.log(this.form);
    },
    getBmiBlur() { // 失去焦点计算BMI 60kg/((160cm/100)^2)
      if (this.memberForm.height && this.memberForm.weight) {
        const bmi = (this.memberForm.weight / ((this.memberForm.height / 100) * (this.memberForm.height / 100))).toFixed(2);
        this.$set(this.memberForm, 'bmi', bmi);
      } else {
        this.$set(this.memberForm, 'bmi', '');
      }
    },
    isEdit() { // 取消编辑
      this.$emit('isEdit', false);
    },
    save() { // 保存会员信息
      this.setMemberData();
    },
    getMemberSavaParams() { // 获取保存or编辑会员参数
      let flag = false;
      let params = this.memberForm;
      // let { province, city, area } = this.$refs.areaSelectPicker.selectItem;
      // province = province ? province + ',' : '';
      // city = city ? city + ',' : '';
      // area = area ? area : '';
      this.$refs.memberForm.validate(valid => { flag = valid; }); // 校验
      if (flag) {
        params.memberFamilyList = this.memberFamilyList;
        params.memberLabelIds = this.memberLabelIds;
        // params.memberLabelIds = [params.memberLabelId];
        // params.memberAddress = province + city + area;
        params.enterpriseId = this.loginData.enterpriseId;
        params.enterpriseName = this.loginData.nickName;
        if (params.memberId) {
          params.id = params.memberId;
        }
        return params;
      } else {
        this.$message.error('请完善必填信息！');
        return false;
      }
    },
    setMemberData(cb) { // 发起会员添加or编辑请求
      if (!this.getMemberSavaParams()) return;
      console.log(this.getMemberSavaParams());
      this.$https.post('system/member/saveOrUpdate', this.getMemberSavaParams()).then(res => {
        if (res.code === 200) {
          this.$message.success('会员保存成功！');
          this.$emit('isEdit', false);
        } else {
          this.$message.error('会员保存失败！');
        }
      }).catch(res => {

      })
    },
    getUrls(args, string) {
      this.memberForm[string] = JSON.stringify(args[0]);
      console.log(this.memberForm[string], string);
    },
    // =================================================================================== 家庭成员 -s
    addRelationshp() { // 添加家庭关系
      this.memberFamilyList.push({ relationship: '', familyName: '', photoNumber: '' });
    },
    delRelationshp(index, id) {
      let len = this.memberFamilyList.length;
      let self = this;
      if (id) {
        this.delFamilyItem(id, () => {
          this.memberFamilyList.splice(index, 1);
        })
      } else {
        this.memberFamilyList.splice(index, 1);
      }
    },
    delFamilyItem(id, cb) { // 删除家庭成员
      let self = this;
      this.$confirm('此操作将永久删除该家庭成员, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        self.$https.get('system/memberFamily/deleteById', { id: id }).then(res => {
          self.$message.success('删除成功');
          cb && cb();
        }).catch(res => {
          // this.$message.error('删除失败，接口请求异常');
        })
      })
    },
    // =================================================================================== 家庭成员 -e
    getStoreId(item) { // 选中门店
      this.memberForm.storeId = item.id;
      this.memberForm.storeName = item.storeName;
      this.memberForm.healthManagePersonName = item.healthManagePersonName;
      this.memberForm.healthManagePersonId = item.healthManagePersonId;
    },
    getStoreList() {  // 获取门店列表
      this.$https.get('system/store/findAll', { enterpriseId: this.loginData.enterpriseId }).then(res => {
        this.storeList = res.data || [];
        console.log('获取门店列表========>', res);
      }).catch(res => {

      })
    },
    getLabelList() { // 获取会员标签列表
      this.$https.get('system/memberLabel/list', {}).then(res => {
        this.memberLabelList = res.data || [];
        console.log('获取会员标签列表========>', res);
      }).catch(res => {

      })
    },
    getMemberRules() { // 获取会员校验规则
      return {
        memberName: { required: true, message: '请输入姓名', trigger: 'blur' },
        photoNumber: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!validate.isvalidPhone(value)) {
                console.log(self);
                return callback(new Error('手机格式不正确！'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        // memberAge: { required: true, message: '请输入年龄', trigger: 'blur' },
        memberSex: { required: true, message: '请选择性别', trigger: 'change' },
        // memberLabelIds: { required: self.pageType == '2', message: '请选择会员类型', trigger: 'change' },
        // memberLabelId: { required: true, message: '请选择慢病情况', trigger: 'change' },
        memberLevel: { required: true, message: '请选择会员等级', trigger: 'change' },
        storeName: { required: true, message: '请选择归属门店', trigger: 'change' },
        // handlerPerson: { required: true, message: '请选择所属人员', trigger: 'change' },
      }
    },
    getMemberInfo() { // 获取会员信息
      if (this.memberId) {
        this.$https.get('system/memberArchives/getArchivesInfoByMemberId', { memberId: this.memberId, enterpriseId: this.loginData.enterpriseId }).then(res => {
          this.memberForm = res.data || {};
          // this.memberForm
          // Object.assign(this.memberForm, this.memberForm.memberInfo);
          this.initMemberForm();
          console.log('获取会员详情========>', res);
        }).catch(res => {

        })
      }
    },
    initMemberForm() { // 初始化表单数据
      if (this.memberForm.memberLabelIds && this.memberForm.memberLabelIds.length > 0) {
        this.memberLabelIds = this.memberForm.memberLabelIds;
        // this.memberForm.memberLabelId = this.memberForm.memberLabelIds[0];
      }
      this.memberFamilyList = this.memberForm.memberFamilyList || [];
      this.filingMaterials = (this.memberForm.filingMaterials && JSON.parse(this.memberForm.filingMaterials)) || [];
      this.inspectionReport = (this.memberForm.inspectionReport && JSON.parse(this.memberForm.inspectionReport)) || [];
      this.areaList = [];
      if (this.memberForm.province && this.memberForm.city && this.memberForm.area) {
        this.areaList = [this.memberForm.province, this.memberForm.city, this.memberForm.area];
      }
      if (this.memberForm.memberLabelNames) {
        this.memberForm.memberLabelNames = this.memberForm.memberLabelNames && this.memberForm.memberLabelNames.split('、');
      }
      this.getBmiBlur();
    },
  }
}
</script>

<style lang="less" scoped>
.baseInp {
    width: 300px;
}
.smallInp {
    width: 150px;
}
.familsItem {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    margin-bottom: 15px;
    margin-left: 30px;
    .familsInp {
        margin-right: 15px;
        .label {
            margin-right: 15px;
            font-size: 14px;
            font-weight: bold;
            color: #606266;
        }
    }
}
.myDivider {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    margin: 20px 0;
    background: #f1f1f1;
    border-left: 4px solid #f56c6c;
    font-size: 15px;
    font-weight: bold;
}
.label_width {
    width: 100%;
}
.tip {
    color: red;
    font-size: 14px;
    font-weight: bold;
}
.tips {
    text-align: center;
    color: red;
    font-size: 14px;
    font-weight: bold;
}
.baseInfoBtns {
    text-align: center;
}
.label_tag {
    margin-right: 15px;
}
</style>
